import * as Yup from 'yup';
import { PHONE_REGEX } from '../../shared/constants/regex';
import { CONTACT_METHOD_TYPE } from '../constants/addPersonFormConstants';

const addPersonSchema = Yup.object({
  FirstName: Yup.string().required('First Name is required'),
  LastName: Yup.string().required('Last Name is required'),

  Height: Yup.string()
    .nullable()
    .max(3, 'Height cannot exceed 3 digits')
    .test('height-format', 'Invalid height. E.g. 501 = 5ft 1in, 611 = 6ft 11in', (value) => {
      if (!value) return true;
      return String(value).length >= 3;
    })
    .test('height-inches', 'Inches must be between 00 and 11', (value) => {
      if (!value || String(value).length < 3) return true;
      return parseInt(String(value).slice(-2), 10) <= 11;
    }),

  Weight: Yup.string()
    .nullable()
    .max(3, 'Weight cannot exceed 3 digits')
    .test('weight-positive', 'Weight must be greater than 0', (value) => {
      if (!value) return true;
      const numValue = parseInt(String(value), 10);
      return !isNaN(numValue) && numValue > 0;
    }),

  SSN: Yup.string()
    .nullable()
    .test('ssn-length', 'SSN value cannot be less than 9 digits', (value) => {
      if (!value) return true;
      return value.replace(/-/g, '').length === 9;
    }),

  ContactInfo: Yup.string()
    .nullable()
    .when('ContactMethodType', {
      is: CONTACT_METHOD_TYPE.PHONE,
      then: (schema) =>
        schema.test('phone-format', 'Invalid phone number', (value) => {
          if (!value) return true;
          return PHONE_REGEX.test(value);
        }),
    })
    .when('ContactMethodType', {
      is: CONTACT_METHOD_TYPE.EMAIL,
      then: (schema) => schema.email('Invalid email address'),
    }),
});

export default addPersonSchema;
